export enum OcDragItemType {
    Fields,
    Level,
    Measure,
    LevelAndMeasure
}
